import React from 'react';
import { useNavigate } from "react-router-dom";
import '../styles/notfound.css';
import leftImage from '../assets/landing1.png';
import warningIcon from '../assets/warningicon.png'; // Add a warning icon asset

const NotFound = () => {
  const navigate = useNavigate();

  const handleRegistrationRedirect = () => {
  navigate("/signinform"); 
};

  return (
    <div className="notfound-page">
      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right NotFound Section */}
      <div className="right-side">
        <div className="notfound-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>
          
          <div className="notfound-content">
            {/* Warning Icon */}
            <div className="icon-container">
              <img src={warningIcon} alt="Warning" className="warning-icon" />
            </div>
            
            {/* NotFound Message */}
            <p className="notfound-message">
              Registration is not found. Kindly register to create your Lingayat Weds account.
            </p>

            {/* Go to Registration Button */}
         <button 
  type="button" 
  className="register-btn"
  onClick={handleRegistrationRedirect}
>
  Go to Registration Page
</button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;